module.exports = __webpack_public_path__ + "img/word2.620c4bd5.webp";